import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps } from "vue";
const _hoisted_1 = {
  class: "app-credit"
};
const _hoisted_2 = {
  class: "toolbox"
};
const _hoisted_3 = {
  class: "wrapper"
};

const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "客户名称", -1);

const _hoisted_5 = {
  class: "wrapper"
};

const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "提交人", -1);

const _hoisted_7 = {
  class: "wrapper"
};

const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "所属团队", -1);

const _hoisted_9 = {
  class: "wrapper"
};

const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "审核状态", -1);

const _hoisted_11 = /*#__PURE__*/_createTextVNode("查询");

const _hoisted_12 = /*#__PURE__*/_createTextVNode("重置");

const _hoisted_13 = /*#__PURE__*/_createTextVNode("免审人员管理");

const _hoisted_14 = ["onClick"];
const _hoisted_15 = {
  key: 1
};
const _hoisted_16 = {
  style: {
    "display": "flex",
    "flex-wrap": "wrap"
  }
};

const _hoisted_17 = /*#__PURE__*/_createTextVNode("通过");

const _hoisted_18 = /*#__PURE__*/_createTextVNode("驳回");

const _hoisted_19 = {
  class: "audit-modal",
  style: {
    "min-height": "100px"
  }
};

const _hoisted_20 = /*#__PURE__*/_createTextVNode("回款信息确认，团队已收款，审核通过");

const _hoisted_21 = {
  class: "fail-list"
};

const _hoisted_22 = /*#__PURE__*/_createTextVNode("团队未收到回款");

const _hoisted_23 = /*#__PURE__*/_createTextVNode("团队收到回款与提交回款信息存在差异");

const _hoisted_24 = /*#__PURE__*/_createTextVNode("回款金额与回款凭证不一致");

const _hoisted_25 = /*#__PURE__*/_createTextVNode("其他");

const _hoisted_26 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_27 = /*#__PURE__*/_createTextVNode("确定");

const _hoisted_28 = {
  class: "member-modal"
};
const _hoisted_29 = {
  class: "toolbox1",
  style: {
    "margin-bottom": "10px"
  }
};

const _hoisted_30 = /*#__PURE__*/_createTextVNode("新增");

const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", {
  class: "tips"
}, "免审人员：以下人员提交回款信息后团队无需审核自动通过", -1);

const _hoisted_32 = /*#__PURE__*/_createTextVNode("删除");

const _hoisted_33 = /*#__PURE__*/_createTextVNode("关闭");

import { ref, reactive, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { getVexTableProps } from '@/config';
import { getSalemanSupplier } from '@/request';
import { ElMessageBox, ElMessage } from 'element-plus';
import Axios from '@/request/createAxiosInstalce';
import SalesmanModal from '../components/salesman-modal.vue';
export default {
  name: 'index',

  setup(__props) {
    const router = useRouter();
    onMounted(() => getOptions());
    const custOptions = [{
      name: '全部',
      value: ''
    }, {
      name: '待审核',
      value: '0'
    }, {
      name: '审核驳回',
      value: '2'
    }, {
      name: '审核通过',
      value: '1'
    }, {
      name: '免审',
      value: '11'
    }];
    const supplierList = ref([]);
    const search = reactive({
      custName: '',
      userKeyword: '',
      supplierId: '',
      repaymentStatus: ''
    });
    const salesmanModalShow = ref(false);
    const init = ref(false);

    function getOptions() {
      getSalemanSupplier().then(res => {
        supplierList.value = res.data;
      }).finally(() => init.value = true);
    }

    const table = ref();
    const tableOptions = getVexTableProps({
      columns: [{
        title: '审核状态',
        field: 'repaymentStatusStr',
        width: 100
      }, {
        title: '客户名称',
        field: 'custName'
      }, {
        title: '客户区域',
        field: 'adCode'
      }, {
        title: '回款金额',
        field: 'repaymentAmount',
        width: 100
      }, {
        title: '回款凭证',
        field: 'voucherUrl',
        width: 360,
        slots: {
          default: 'voucherUrl'
        }
      }, {
        title: '涉及订单',
        field: 'orderCodeCount',
        width: 80,
        slots: {
          default: 'orderCodeCount'
        }
      }, {
        title: '提交人',
        field: 'submitter'
      }, {
        title: '所属团队',
        field: 'supplierName'
      }, {
        title: '创建时间',
        field: 'applyTime'
      }, {
        title: '审核',
        slots: {
          default: 'operation'
        },
        width: 110
      }],
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(resolve => {
            let params = {
              page: page.currentPage,
              pageSize: page.pageSize,
              custName: search.custName,
              userKeyword: search.userKeyword,
              repaymentStatus: search.repaymentStatus
            };

            if (search.supplierId) {
              params.supplierIds = search.supplierId;
            } else {
              params.supplierIds = supplierList.value.map(v => v.supplier_id).join();
            }

            Axios.get('/admin/creditManage/repaymentCust/list', {
              params
            }).then(res => {
              if (!res.data.success) return;
              resolve({
                total: res.data.data.total,
                result: res.data.data.list
              });
            });
          })
        }
      }
    });
    const auditModal = ref({
      show: false,
      type: 'success',
      failType: '1',
      failMsg: '',
      data: {}
    });

    function auditHandle(type, row) {
      auditModal.value = {
        show: true,
        type,
        failType: '1',
        failMsg: '',
        data: row
      };
    }

    function auditComfirmHandle() {
      let body = {
        creditRepaymentId: auditModal.value.data.creditRepaymentId,
        repaymentStatus: auditModal.value.type === 'success' ? '1' : '2'
      };

      if (auditModal.value.type === 'fail') {
        body.rejectReason = auditModal.value.failType === '其他' ? auditModal.value.failMsg : auditModal.value.failType;
      }

      Axios.post('/admin/creditManage/repaymentCust/audit', body, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(res => {
        let {
          success,
          msg
        } = res.data;

        if (success) {
          ElMessage.success('操作成功');
          table.value.commitProxy('reload');
        } else {
          ElMessage.error(msg);
        }
      }).finally(() => auditModal.value.show = false);
    }

    const auditUsersModalShow = ref(false);
    const auditUsers = ref([]);

    function getSalesmanList() {
      let params = {
        supplierIds: supplierList.value.map(v => v.supplier_id).join(),
        isExempt: 1,
        isPage: 0
      };
      return Axios.get('/admin/creditManage/getSalesmanList', {
        params
      }).then(res => {
        auditUsers.value = res.data.data;
      });
    }

    function auditModalAction() {
      getSalesmanList().then(() => auditUsersModalShow.value = true);
    }

    function addAuditUserHandle(list) {
      let body = list.map(v => v.supUserId);
      Axios.post('/admin/creditManage/exemptUser/add', body).then(res => {
        let {
          success,
          msg
        } = res.data;

        if (success) {
          ElMessage.success('操作成功');
          getSalesmanList();
        } else {
          ElMessage.error(msg);
        }
      });
    }

    function auditUserRemoveHandle(data) {
      ElMessageBox.confirm('确认删除吗?', '提示', {
        type: 'warning'
      }).then(() => {
        let body = [data.supUserId];
        Axios.post('/admin/creditManage/exemptUser/delete', body).then(res => {
          let {
            success,
            msg
          } = res.data;

          if (success) {
            ElMessage.success('操作成功');
            getSalesmanList();
          } else {
            ElMessage.error(msg);
          }
        });
      });
    }

    function getImages(imageUrl) {
      if (!imageUrl) return [];
      return imageUrl.split(',');
    }

    function toOrderPage(orderCode) {
      router.push({
        name: 'TeamOrder',
        query: {
          orderCode
        }
      });
    }

    function reset() {
      Object.keys(search).forEach(key => search[key] = '');
      table.value.commitProxy('reload');
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_image = _resolveComponent("el-image");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      const _component_el_radio = _resolveComponent("el-radio");

      const _component_el_dialog = _resolveComponent("el-dialog");

      const _component_el_table_column = _resolveComponent("el-table-column");

      const _component_el_table = _resolveComponent("el-table");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createVNode(_component_el_input, {
        modelValue: search.custName,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => search.custName = $event),
        placeholder: "请输入名称"
      }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_5, [_hoisted_6, _createVNode(_component_el_input, {
        modelValue: search.userKeyword,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => search.userKeyword = $event),
        placeholder: "请输入名称"
      }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_7, [_hoisted_8, _createVNode(_component_el_select, {
        modelValue: search.supplierId,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => search.supplierId = $event),
        placeholder: "请选择团队",
        style: {
          "width": "200px"
        }
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(supplierList.value, item => {
          return _openBlock(), _createBlock(_component_el_option, {
            value: item.supplier_id,
            label: item.supplier_name,
            key: item.supplier_id
          }, null, 8, ["value", "label"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_9, [_hoisted_10, _createVNode(_component_el_select, {
        modelValue: search.repaymentStatus,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => search.repaymentStatus = $event),
        style: {
          "width": "140px"
        }
      }, {
        default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(custOptions, item => {
          return _createVNode(_component_el_option, {
            value: item.value,
            label: item.name,
            key: item.value
          }, null, 8, ["value", "label"]);
        }), 64))]),
        _: 1
      }, 8, ["modelValue"])]), _createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[4] || (_cache[4] = $event => table.value.commitProxy('reload'))
      }, {
        default: _withCtx(() => [_hoisted_11]),
        _: 1
      }), _createVNode(_component_el_button, {
        type: "primary",
        onClick: reset
      }, {
        default: _withCtx(() => [_hoisted_12]),
        _: 1
      })]), _createVNode(_component_el_button, {
        type: "primary",
        onClick: auditModalAction
      }, {
        default: _withCtx(() => [_hoisted_13]),
        _: 1
      }), init.value ? (_openBlock(), _createBlock(_component_vxe_grid, _mergeProps({
        key: 0,
        ref_key: "table",
        ref: table
      }, _unref(tableOptions)), {
        orderCodeCount: _withCtx(({
          row
        }) => [row.orderCodeCount ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          href: "javascript:;",
          onClick: $event => toOrderPage(row.orderCode)
        }, _toDisplayString(row.orderCodeCount), 9, _hoisted_14)) : (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(row.orderCodeCount), 1))]),
        voucherUrl: _withCtx(({
          row
        }) => [_createElementVNode("div", _hoisted_16, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getImages(row.voucherUrl), (item, index) => {
          return _openBlock(), _createBlock(_component_el_image, {
            style: {
              "width": "80px",
              "height": "80px",
              "flex": "0 0 80px",
              "margin": "0 5px 5px 0"
            },
            key: index,
            "preview-src-list": [item],
            src: item
          }, null, 8, ["preview-src-list", "src"]);
        }), 128))])]),
        operation: _withCtx(({
          row
        }) => [row.repaymentStatusStr === '待审核' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createVNode(_component_el_button, {
          type: "primary",
          link: "",
          onClick: $event => auditHandle('success', row)
        }, {
          default: _withCtx(() => [_hoisted_17]),
          _: 2
        }, 1032, ["onClick"]), _createVNode(_component_el_button, {
          type: "danger",
          link: "",
          onClick: $event => auditHandle('fail', row)
        }, {
          default: _withCtx(() => [_hoisted_18]),
          _: 2
        }, 1032, ["onClick"])], 64)) : _createCommentVNode("", true)]),
        _: 1
      }, 16)) : _createCommentVNode("", true), _createVNode(_component_el_dialog, {
        modelValue: auditModal.value.show,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => auditModal.value.show = $event),
        title: "审核",
        width: "500px"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[10] || (_cache[10] = $event => auditModal.value.show = false)
        }, {
          default: _withCtx(() => [_hoisted_26]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: auditComfirmHandle
        }, {
          default: _withCtx(() => [_hoisted_27]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_19, [auditModal.value.type === 'success' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_hoisted_20], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createElementVNode("div", _hoisted_21, [_createVNode(_component_el_radio, {
          modelValue: auditModal.value.failType,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => auditModal.value.failType = $event),
          label: "团队未收到回款"
        }, {
          default: _withCtx(() => [_hoisted_22]),
          _: 1
        }, 8, ["modelValue"]), _createVNode(_component_el_radio, {
          modelValue: auditModal.value.failType,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => auditModal.value.failType = $event),
          label: "团队收到回款与提交回款信息存在差异"
        }, {
          default: _withCtx(() => [_hoisted_23]),
          _: 1
        }, 8, ["modelValue"]), _createVNode(_component_el_radio, {
          modelValue: auditModal.value.failType,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => auditModal.value.failType = $event),
          label: "回款金额与回款凭证不一致"
        }, {
          default: _withCtx(() => [_hoisted_24]),
          _: 1
        }, 8, ["modelValue"]), _createVNode(_component_el_radio, {
          modelValue: auditModal.value.failType,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => auditModal.value.failType = $event),
          label: "其他"
        }, {
          default: _withCtx(() => [_hoisted_25]),
          _: 1
        }, 8, ["modelValue"])]), auditModal.value.failType == '其他' ? (_openBlock(), _createBlock(_component_el_input, {
          key: 0,
          modelValue: auditModal.value.failMsg,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => auditModal.value.failMsg = $event),
          placeholder: "限制30个字符",
          maxlength: "30"
        }, null, 8, ["modelValue"])) : _createCommentVNode("", true)], 64))])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
        modelValue: auditUsersModalShow.value,
        "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => auditUsersModalShow.value = $event),
        title: "免审人员管理",
        width: "70%",
        top: "50px"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[13] || (_cache[13] = $event => auditUsersModalShow.value = false)
        }, {
          default: _withCtx(() => [_hoisted_33]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[12] || (_cache[12] = $event => salesmanModalShow.value = true),
          style: {
            "margin-bottom": "10px"
          }
        }, {
          default: _withCtx(() => [_hoisted_30]),
          _: 1
        }), _hoisted_31]), _createVNode(_component_el_table, {
          data: auditUsers.value
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            label: "姓名",
            prop: "linkMan"
          }), _createVNode(_component_el_table_column, {
            label: "所属团队",
            prop: "supplierName"
          }), _createVNode(_component_el_table_column, {
            label: "角色名称",
            prop: "employeeName"
          }), _createVNode(_component_el_table_column, {
            label: "操作"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_button, {
              type: "danger",
              link: "",
              onClick: $event => auditUserRemoveHandle(scope.row)
            }, {
              default: _withCtx(() => [_hoisted_32]),
              _: 2
            }, 1032, ["onClick"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["data"])])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(SalesmanModal, {
        modelValue: salesmanModalShow.value,
        "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => salesmanModalShow.value = $event),
        supplierList: supplierList.value,
        type: "audit",
        onSuccess: addAuditUserHandle
      }, null, 8, ["modelValue", "supplierList"])]);
    };
  }

};